import axios from 'axios';

export const apiClient = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000,
});

apiClient.interceptors.request.use((config) => {
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
    }
    return config;
});

export const initializeApiClient = (apiBaseUrl) => {
    apiClient.defaults.baseURL = apiBaseUrl;
};

export default apiClient;